export default "__VITE_ASSET__DWRHADiZ__"